"use client";
import FullscreenExitRoundedIcon from '@mui/icons-material/FullscreenExitRounded';
import { ZoomInOutButtons } from '@wt/app/game/_components/ZoomInOutButtons';
import { isNil } from 'lodash';
import { ImageProps } from "next/image";
import { forwardRef, memo, useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

import ModalLayout from '../layouts/ModalLayout';
import { smallButtonClasses } from '@wt/shared/components/buttons/SmallButton';

function ImageModel(props: ImageProps) {
  return (
    <ModalLayout htmlFor={props.id ?? ''}>
      <ModalTransformWrapper {...props} />
    </ModalLayout>
  );
}

export const ModalTransformWrapper = (
  props: ImageProps & { handleClose?: () => void }
) => {
  const isVideo = props.src && props.src.toString().indexOf('.mp4') !== -1;
  const src = props.src as unknown as string;
  const [panning, setPanning] = useState(false);
  const inAdminModal = !isNil(props.handleClose);

  return (
    <TransformWrapper
      disablePadding={true}
      centerOnInit={true}
      doubleClick={{ disabled: true }}
      onPanningStart={() => {
        setPanning(true);
      }}
      onPanningStop={() => {
        setPanning(false);
      }}
      wheel={{
        smoothStep: 0.01,
      }}
      pinch={{
        step: 0.01,
      }}
      maxScale={25}
    >
      <div className="absolute inset-0 items-center justify-center bg-black">
        <PuzzleImage isVideo={isVideo} src={src} panning={panning} />
      </div>
      <div className="absolute right-4 top-4 z-[99]">
        {inAdminModal ? (
          <div
            onClick={props.handleClose}
            className={`pointer-events-auto mr-4 ${smallButtonClasses}`}
          >
            <FullscreenExitRoundedIcon htmlColor="black" />
          </div>
        ) : (
          <label
            htmlFor={props.id ?? ''}
            className={`pointer-events-auto mr-4 ${smallButtonClasses}`}
          >
            <FullscreenExitRoundedIcon htmlColor="black" />
          </label>
        )}
        <ZoomInOutButtons />
      </div>
    </TransformWrapper>
  );
};

const PuzzleImage = ({ isVideo, src, panning }: { isVideo: boolean | '', src: string, panning: boolean}) => {
  return isVideo ? (
    <div className="relative size-full overflow-hidden bg-black">
      <video
        src={src}
        className="size-full bg-black"
        loop={true}
        autoPlay={true}
        controls
      ></video>
    </div>
  ) : (
    <TransformComponent
      wrapperStyle={{
        margin: 'auto',
        width: '100%',
        height: '100%',
        cursor: panning ? 'grabbing' : 'default',
      }}
      contentStyle={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        objectPosition: 'center',
      }}
    >
      <img
        src={src}
        alt=""
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'center',
        }}
        className='size-full max-h-full max-w-full bg-black object-cover object-center transition-all duration-300 ease-linear'
      />
    </TransformComponent>
  );
};

const MemoModal = memo(ImageModel);
export default MemoModal;
